/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import { DataTableList } from "../../components/DataTable/DataTableList";
import TopBar from "../../components/TopBar";
import DeleteConfirmationPopup from "../../components/DeleteConfirmationPopup";
import { discountType } from "../../utils/constants";
import { getCoupons, deleteCoupons } from "../../api/couponsApi";

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import down from "../../assets/images/icondropdown.svg";
import searchIcon from "../../assets/images/icon-search.svg";

import styles from './coupon.module.css'

const Coupon = () => {

    const popupRef = useRef()
    const dropdownRef = useRef()

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedType, setSelectedType] = useState([]);
    const [searchInput, setSearchInput] = useState('');

    const [couponList, setCouponList] = useState([])

    const fetchCoupons = async () => {
        try {
            setIsLoadingData(true);
            const response = await getCoupons(
                {
                    page: currentPage,
                    search: searchInput,
                    type: selectedType?.join(',') || "",
                    sortBy: 'createdAt',
                }
            );
            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false);
            }
            if (response?.success) {
                setCouponList(response?.data?.result || []);
                setTotalPage(response?.data?.totalPages || []);
            }
        } catch (error) {
            console.log('Error fetching coupons:', error);
            setCouponList([]);
            setIsLoadingData(false);
        }
    };

    useEffect(() => {
        fetchCoupons();
    }, [currentPage, selectedType]);

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = couponList?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = Math?.max(dataValue?.length, title?.length);

                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});

            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {
                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});
                setColumnWidths(widthMap);
            }
            resolve();
        });
    };

    useEffect(() => {
        if (couponList?.length > 0) {
            calculateColumnWidths();
        }
    }, [couponList]);

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (Object?.keys(columnWidths)?.length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(couponList?.map((row) => row?.couponId));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleCouponChange = (coupon) => {
        setSelectedType(prev => {
            if (prev.includes(coupon)) {
                return prev.filter(c => c !== coupon);
            } else {
                return [...prev, coupon];
            }
        });
    }

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            if (deleteTarget.type === "single") {
                await deleteCoupons([deleteTarget?.row?.couponId]);
            }

            if (deleteTarget.type === "multiple") {
                await deleteCoupons(deleteTarget?.rows);
                setSelectedRows([]);
                setIsAllSelected(false);
                setToggleSelect(prev => !prev);
            }

            await fetchCoupons();
        } catch (error) {
            console.error('Error deleting coupons:', error);
        }

        setShowDeletePopup(false);
        setDeleteTarget(null);
    };

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const columns = [
        {
            name: 'Code',
            selector: (row) => row?.couponCode,
            cell: (row) => <div className='editTitle'><Link to={`/coupon/${row?.couponId}`}>{row?.couponCode}</Link></div>,
            sortable: true,
            minWidth: columnWidths['couponCode'] && (parseInt(columnWidths['couponCode']) + 50 > 300) ? '300px' : `${parseInt(columnWidths['couponCode']) + 50}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Discount type',
            selector: (row) => row?.discountType,
            cell: (row) => <div className='editTitle'>{row?.discountType === 'PERCENTAGE_DISCOUNT' ? 'Percentage Discount' : 'Fixed discount'}</div>,
            sortable: true,
            width: columnWidths['discountType'] && `${parseInt(columnWidths['discountType']) + 40}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Coupon amount',
            selector: (row) => row?.couponAmount,
            cell: (row) => <div className='editTitle'>{row?.type !== 'Percentage discount' && "₹"}{row?.couponAmount}{row?.type === 'Percentage discount' && "%"}</div>,
            sortable: true,
            width: columnWidths['couponAmount'] && `${parseInt(columnWidths['couponAmount']) + 80}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Expiry date',
            selector: (row) => row?.couponExpiryDate,
            cell: (row) => <div>{moment(row?.couponExpiryDate).tz("Asia/Kolkata").format("DD MMM, YYYY")}</div>,
            sortable: true,
            width: columnWidths['couponExpiryDate'] && `${parseInt(columnWidths['couponExpiryDate']) - 90}px`,
            style: { width: columnWidths['couponExpiryDate'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <Link to={`/coupon/${row?.couponId}`}>
                        <button className="edit-btn"><img src={penIcon} alt="pen-icon" /></button>
                    </Link>
                    <button className="delete-btn" onClick={() => {
                        setDeleteTarget({ type: "single", row });
                        setShowDeletePopup(true);
                    }}><img src={Delete} alt="delete-icon" />
                    </button>
                </div>
            ),
            width: "90px"
        }
    ];

    const handleSearch = async () => {
        await fetchCoupons()
    }

    return (
        <div className={`${styles.couponList} ${couponList?.length <= 10 && `${styles.couponListHeight}`}`}>
            <TopBar />

            <div className={`${styles.couponDatatableList}`}>

                <div className={`${styles.couponHeader}`}>
                    {/* <div className={`${styles.couponHeading}`}>Coupons</div> */}
                    <div className={`${styles.leftSide}`}>
                        <div className={`${styles.searchBar}`}>
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search by code..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </div>
                        <button className={`add-btn`} onClick={() => handleSearch()}>Search</button>
                    </div>
                    <div className={`${styles.actionButtonsDeleteAdd}`}>
                        <div className={`${styles.leftSide}`}>
                        </div>
                        <div className="dropdown-wrapper order-status-dropdown" ref={dropdownRef}>
                            <div className="dropdown-header" onClick={() => setOpen(!open)}>
                                <span className="title">Type</span>
                                <span className={`arrow ${open ? "rotate" : ""}`}><img src={down} alt="down-icon"/></span>
                            </div>
                            {open && (
                                <div className="dropdown-list" >
                                    {Object.entries(discountType).map(([key, label]) => (
                                        <label key={key}
                                            onChange={() => handleCouponChange(key)}
                                            className="dropdown-item" >
                                            <input
                                                type="checkbox"
                                                checked={selectedType.includes(key)}
                                            />
                                            <span>{label}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>
                        <Link to='/add-coupon'>
                            <button className='add-btn'>Add Coupon</button>
                        </Link>
                        {selectedRows?.length > 0 && (
                            <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${couponList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={couponList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows?.map((row) => row?.couponId);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === couponList?.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    // noDataComponent={<NoResultsPublication />}
                    />
                </div>
            </div>
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={popupRef}
                title={deleteTarget?.type === "single" ? 'coupon' : selectedRows?.length === 1 ? 'coupon' : `coupons`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete coupon ${deleteTarget?.row?.couponCode}?` : selectedRows?.length === 1 ? `Are you sure you want to delete coupon?` : `Are you sure you want to delete ${selectedRows?.length} coupons?`}
                confirmDelete={confirmDelete}
            />
        </div>
    )
}
export default Coupon;